<template>
  <div class="col-sm-12">
    <div
      class="data-list-item add"
      @click.stop="$emit('add')"
    >
      <div class="item-img-cont add-title">
        <i class="fa fa-plus" />
      </div>
      <div class="item-text-cont">
        <span class="item-title-add">
          {{ $t('common.add_new') }}
        </span>
        <font-awesome-icon
          icon="calendar-check"
          class="card-body-icon"
        />
      </div>
    </div>

    <Transition name="fade">
      <div
        v-if="results && results.length"
        class="col-sm-12 data-container"
      >
        <div
          v-for="result of results"
          :key="result.id"
          class="data-list-item"
          @click.stop="$emit('edit', result)"
        >
          <div class="col-sm-12 item-header">
            <div class="item-img-cont">
              <font-awesome-icon icon="coins" />
            </div>
            <div
              class="item-text-cont"
            >
              <span class="item-title">
                {{ result.name }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>

export default {
    name: 'ObservationCollectionList',
    props: {
        results: {
            type: Array,
            default: function () {
                return []
            },
        }
    }
}
</script>
